// extracted by mini-css-extract-plugin
export default {"header":"HistoryHeader_header__OgW-+","item":"HistoryHeader_item__2SW+d"};